import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Lock, ArrowUp } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import useThemeStyles from '../../theme/useThemeStyles';

/**
 * Call-to-action prompting user to upgrade from free/trial plan
 * @param {String} reason - What feature is locked (e.g. "file uploads", "AI messages", "Staff Scheduler")
 * @param {Boolean} compact - Use compact layout
 */
const UpgradeCTA = ({ reason = 'this feature', compact = false }) => {
  const navigate = useNavigate();
  const styles = useThemeStyles();

  return (
    <Box sx={{ p: compact ? 2 : 3, textAlign: 'center' }}>
      <Lock size={compact ? 32 : 48} weight="regular" style={{ margin: '0 auto 16px', color: '#999', display: 'block' }} />
      <Typography variant={compact ? 'subtitle1' : 'h6'} gutterBottom>
        Upgrade to unlock {reason}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {compact
          ? 'Upgrade your plan to access this feature.'
          : 'This feature requires a paid plan. Upgrade to continue.'}
      </Typography>
      <Button
        variant="contained"
        size={compact ? 'small' : 'medium'}
        startIcon={<ArrowUp size={20} />}
        onClick={() => navigate('/supplier/billing')}
        sx={styles.button?.primary}
      >
        Upgrade Plan
      </Button>
    </Box>
  );
};

export default UpgradeCTA;
